<section class="pagina">
  @if (titolo() || sottotitolo()) {
    <header class="pagina__intestazione">
      <div class="pagina__titoli">
        @if (titolo()) {
          <h1 class="pagina__titolo">{{ titolo() }}</h1>
        }
        @if (sottotitolo()) {
          <p class="pagina__sottotitolo">{{ sottotitolo() }}</p>
        }
      </div>
      <div class="pagina__azioni">
        <ng-content select="[azioni]" />
      </div>
    </header>
  }

  <div class="pagina__corpo">
    <ng-content />
  </div>

  <div class="pagina__piede">
    <ng-content select="[piede]" />
  </div>
</section>
